import api from "../utils/axios/axiosConfig";

const expensesService = {
  create: (data) => api.post("/expenses/create", data),
  update: (id, data) => api.put(`/expenses/update/${id}`, data),
  delete: (id) => api.delete(`/expenses/delete/${id}`),
  get: (id) => api.get(`/expenses/get/${id}`),
  search: (params) => api.post("/expenses/search", params),
};

export default expensesService;
